module.exports = __webpack_public_path__ + "static/media/mobile-view.d31b4afc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/seating-chart/mobile-view.svg
// module id = 678
// module chunks = 49